import { Options, Vue } from 'vue-class-component';
import DeviceAndSlotDetail from '@/views/components/DeviceAndSlotDetail/DeviceAndSlotDetail.vue';
import { PropType } from 'vue';
import {
  DeviceDTO,
  ILinkableObject,
  SlotStatus,
} from '@/../client-generator/generated-clients/plants';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';
import { AUTOMATION_WIZARD_NEXT_CALLED } from '@/core/utils/emitter-events';

@Options({
  name: 'ScenePanelDeviceButtons',
  props: {
    currentDevices: {
      type: Object as PropType<DeviceDTO[]>,
      required: true,
    },
    assignableDevices: {
      type: Object as PropType<DeviceDTO[]>,
      required: true,
    },
    linkableObject: {
      type: Object as PropType<ILinkableObject>,
      required: true,
    },
    addToastMessage: {
      type: String,
      required: true,
    },
    ruleServiceType: {
      type: Number,
      required: true,
    },
    deleteUnusedDevices: {
      type: Boolean,
      default: false,
    },
    isSingleDeviceSelection: {
      type: Boolean,
      default: false,
    },
    isOnlyDeviceSelection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DeviceAndSlotDetail,
  },
})
export default class ScenePanelDeviceButtons extends Vue {
  currentDevices!: DeviceDTO[];
  assignableDevices!: DeviceDTO[];
  linkableObject!: ILinkableObject;
  addToastMessage!: string;
  ruleServiceType!: SlotRuleServiceType;
  deleteUnusedDevices!: boolean;
  isSingleDeviceSelection!: boolean;
  isOnlyDeviceSelection!: boolean;

  searchTerm = '';

  get availableAssignableDevices() {
    return this.assignableDevices.filter(
      (x) =>
        !this.currentDevices?.find((d) => d.id === x.id) &&
        (!this.searchTerm ||
          x.id?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          x.model?.toLowerCase().includes(this.searchTerm.toLowerCase()))
    );
  }

  mounted() {
    this.$emitter.on(
      AUTOMATION_WIZARD_NEXT_CALLED,
      this.deleteUnusedDevicesAction
    );
  }

  beforeUnmount() {
    this.$emitter.off(
      AUTOMATION_WIZARD_NEXT_CALLED,
      this.deleteUnusedDevicesAction
    );
  }

  addDevice(device: DeviceDTO) {
    // if (this.isSingleDeviceSelection) {
    //   for (let i = this.currentDevices.length - 1; i >= 0; i--) {
    //     this.removeDevice(i, true);
    //   }
    // }
    // if (this.isOnlyDeviceSelection) {
    //   const slot = device.slots?.find((k) => !!k);
    //   if (slot) {
    //     slot.status = SlotStatus.MarkedForLinking;
    //     switch (this.ruleServiceType) {
    //       case SlotRuleServiceType.THERMO_THERMO:
    //         slot.assignedComponentType = ComponentType.Thermo;
    //         break;
    //       case SlotRuleServiceType.THERMO_PROBE:
    //         slot.assignedComponentType = ComponentType.Probe;
    //         break;
    //     }
    //   }
    // }
    // this.linkableObject.devices?.push(device);
    // this.$toast.add({
    //   severity: 'success',
    //   summary: this.addToastMessage,
    //   closable: false,
    //   life: 3000,
    // });
  }

  deleteUnusedDevicesAction() {
    if (!this.deleteUnusedDevices) return;
    for (let i = (this.linkableObject.devices?.length ?? 0) - 1; i >= 0; i--) {
      if (
        !this.linkableObject.devices![i].slots?.some(
          (s) =>
            s.status === SlotStatus.MarkedForLinking ||
            (s.status === SlotStatus.Configured &&
              s.linkedObjects?.some((l) => l.id === this.linkableObject.id))
        )
      ) {
        this.linkableObject.devices!.splice(i, 1);
      }
    }
  }
}
